import React from "react";
import "../App.css";
import logo from "../assets/main.jpg";
import SiteNav from "../components/SiteNav";
import DealerResourceSummary from "../components/DealerResourceSummary";
import usePageMeta from "../hooks/usePageMeta";
import { DEALERSHIP } from "../data/dealership";

function Home() {
  usePageMeta({
    title: `${DEALERSHIP.name} (${DEALERSHIP.location}) - Consumer Report`,
    description:
      `Independent consumer report for ${DEALERSHIP.name} in ${DEALERSHIP.location}, covering complaints, reviews, used vehicles, trade-in issues, service, finance, and Ohio reporting resources.`,
  });

  return (
    <>
      <SiteNav />
        <div className="container">
          <div className="container">
            <div className="text-center mt-5 text-uppercase">
            <h1 className="h3">Findlay Chrysler Dodge Jeep Ram - Consumer Report</h1>
            </div>
          </div>
        <div className="container">
          <div className="text-center mt-5 mb-5 text-uppercase">
            <p className="lead">
              <strong>Derrow Automotive / Used Car Sales Fraud</strong>
            </p>
            <a
              href={DEALERSHIP.website}
              target="_blank"
              rel="noreferrer"
            >
              Findlay Chrysler located at: {DEALERSHIP.address}
            </a>
            <p className="mt-2 mb-0">
              Sales, service, and parts phone: {DEALERSHIP.phone}
            </p>
          </div>
        </div>
        <div className="container">
          <img
            src={logo}
            style={{ padding: "0px 20px 0px 20px", maxWidth: 960 }}
            className="rounded mx-auto d-block w-100"
            alt="Findlay Chrysler dealership exterior"
          />
        </div>
        <div className="container py-5" />
        <div className="container">
          <DealerResourceSummary />
          <div className="text-left">
            <p>
              Even in 2026, shoppers still report illegal and fraudulent sales
              practices at dealerships like {DEALERSHIP.name} in {DEALERSHIP.locationLong}. Stay cautious, get
              everything in writing, and do not let time pressure or AS-IS language
              replace full disclosure.
            </p>
            <p>
              In October 2021 I purchased a Jeep Grand Cherokee from Findlay
              Chrysler in Findlay, Ohio. The vehicle had auction history and
              pre-existing damage Sales staff stated it had a single female owner; records
              showed a male owner. Several exterior, interior, and electrical
              components were broken and had been covered up before the sale.
            </p>
            <p>
              After delivery I discovered the adaptive cruise control module,
              steering column controls, and other electronics needed expensive
              repairs. I was shown an iPad checklist that suggested the vehicle was
              fully inspected, but no certification statement was provided during
              signing. The store relied on an AS-IS agreement, leaving little
              transparency.
            </p>
            <p>
              During signing with Rick Duffman, David Siebenaller, Brad Overly,
              Jeremy Chetister, and Amber Johnson, the trade-in allowance was
              reduced by $4,000. The bill of sale reflecting the lower allowance
              was buried near the end of the paperwork. When I questioned it,
              paperwork was quickly sealed and I was told to speak with management
              later.
            </p>
            <p>
              Questions about vehicle condition were met with pressure to sign
              quickly. Requests to know whether obvious issues existed were
              dismissed as overreacting. After returning home to Tennessee,
              additional warning lights appeared; dealership responses were
              dismissive and relied on the AS-IS disclaimer.
            </p>
            <p>
              Based on my experience and public reviews, I believe Findlay Chrysler
              and its ownership (Derrow Automotive) routinely resell auction
              vehicles without disclosing defects. Several Google reviews describe
              similar patterns of undisclosed problems, lack of inspection, and poor
              follow-up.
            </p>
            <div className="container text-center d-grid gap-2 mx-auto m-5">
              <a
                href="https://www.ohioattorneygeneral.gov/individuals-and-families/consumers/file-a-complaint.aspx"
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary active"
                type="button"
                id="cc"
                style={{ backgroundColor: "#0377fc !important" }}
              >
                SUPPORT US BY FILING A REPORT
              </a>
            </div>
            <p>
              This site outlines alleged fraud, illegal sales practices, and
              behaviors taking place at Findlay Chrysler and related ownership. The
              information is shared with federal and state prosecutors and consumer
              protection agencies for investigation. My goal is to hold the
              dealership accountable in Hancock County Common Pleas Court and, if
              appropriate, pursue a class action with other consumers.
            </p>
            <p>
              Derrow Automotive has, in my view, violated consumer sales acts,
              including Ohio fraud statutes. During my sale, staff attempted to
              withhold $4,000 from the trade-in allowance. All electronics were
              represented as fully functional, but several components failed
              immediately after purchase. Questions about condition or financing
              options were brushed aside to close the deal quickly.
            </p>
            <p>
              When additional issues surfaced, responses from management were
              dismissive and relied on the AS-IS clause. I believe Findlay uses
              these agreements to resell damaged auction vehicles at inflated prices
              without disclosing necessary repairs or performing adequate
              inspections.
            </p>
            <div className="container text-center d-grid gap-2 mx-auto m-5">
              <a
                href="https://www.ohioattorneygeneral.gov/individuals-and-families/consumers/file-a-complaint.aspx"
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary active"
                type="button"
                id="cc"
                style={{ backgroundColor: "#0377fc !important" }}
              >
                SUPPORT US BY FILING A REPORT
              </a>
            </div>
            <div className="container text-center mt-5 pt-5">
              <h3>1/5 Star Google Consumer Reviews</h3>
            </div>
            <div className="text-center">
              <ul className="text-start d-inline-block">
                <li>Vehicle delivered with undisclosed mechanical issues (Google 1-star)</li>
                <li>Trade-in value lowered from prior written/phone quotes (Google 1-star)</li>
                <li>Adaptive cruise and parking safety systems inoperable after purchase (Google 1-star)</li>
                <li>Pressure to sign quickly with limited time to review contracts (Google 1-star)</li>
                <li>Claims of no inspection beyond a quick drive (Google 1-star)</li>
                <li>Broken components hidden with temporary fixes (Google 1-star)</li>
                <li>Promises made verbally not reflected in paperwork (Google 1-star)</li>
                <li>Slow or no response from management on defects (Google 1-star)</li>
                <li>Fees and totals changing at signing compared to prior agreements (Google 1-star)</li>
                <li>Buyers advised to rely on AS-IS language instead of transparent disclosure (Google 1-star)</li>
              </ul>
              <p className="mt-3">
                Compare third-party reviews across platforms such as BBB and Yelp.
              </p>
            </div>
            <div className="text-center">
              <a
                href="https://www.google.com/search?q=findlay+chrysler#lrd=0x883ea97cbf957453:0x2f848ed6415761db,1,,,"
                target="_blank"
                rel="noreferrer"
              >
                See more Findlay Chrysler Google Reviews
              </a>
            </div>
            <div className="container mt-5">
              <p>
                These reviews echo similar experiences: damaged auction vehicles,
                minimal inspection, and poor follow-up.
              </p>
              <p>
                "If I could rate less than 1 star I would. I arrived with full
                intentions of purchasing. Payment quotes were higher than promised;
                management was extremely unprofessional." - Review from 11/23/2021
                by{" "}
                <a
                  href="https://www.google.com/maps/contrib/104376085494983195119/place/ChIJU3SVv3ypPogR22FXQdaOhC8/@40.9007693,-84.5263313,7z/data=!4m6!1m5!8m4!1e1!2s104376085494983195119!3m1!1e1?hl=en-US"
                  target="_blank"
                  rel="noreferrer"
                >
                  Dylan Blunk
                </a>
              </p>
              <p>
                "Paid $27,000. The next day several malfunctions occurred. Dealer
                quoted $2,000 to fix what should have been caught on intake. Add
                thousands for what they refuse to address." - Review from 2/15/2022
                by{" "}
                <a
                  href="https://www.google.com/maps/contrib/117924675419850052541/place/ChIJU3SVv3ypPogR22FXQdaOhC8/@35.5139113,-89.0070042,6z/data=!4m6!1m5!8m4!1e1!2s117924675419850052541!3m1!1e1?hl=en-US"
                  target="_blank"
                  rel="noreferrer"
                >
                  Joshua Iannantuono
                </a>
              </p>
              <p>
                "Discovered my parking brake pedal was held by zip ties; the brake
                cable was not connected. Management admitted they do not perform
                inspections beyond a brief drive." - Review from 3/07/2022 by{" "}
                <a
                  href="https://www.google.com/maps/contrib/110917699995212832115/place/ChIJU3SVv3ypPogR22FXQdaOhC8/@41.0586847,-83.682013,17z/data=!4m6!1m5!8m4!1e2!2s110917699995212832115!3m1!1e1?hl=en-US"
                  target="_blank"
                  rel="noreferrer"
                >
                  Brian Wolfe
                </a>
              </p>
            </div>
            <div className="container text-center d-grid gap-2 mx-auto m-5">
              <a
                href="https://www.ohioattorneygeneral.gov/individuals-and-families/consumers/file-a-complaint.aspx"
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary active"
                type="button"
                id="cc"
                style={{ backgroundColor: "#0377fc !important" }}
              >
                SUPPORT US BY FILING A REPORT
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
